import { Paper, Button } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import React, { ReactNode } from 'react';
import { container } from 'services/ioc/ioc';
import { LogService } from 'services/LogService';
import { ErrorBoundaryWrapper } from './styles/ErrorBundaryStyles';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  logService: LogService;

  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.logService = container.get<LogService>(ServiceTypes.LogService);
  }

  static getDerivedStateFromError(error: any): State {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: React.ErrorInfo): void {
    this.logService.logError({ error, info: errorInfo });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryWrapper>
          <Paper>
            <p>Incident details where logged. </p>
            <Button intent='primary' label='Reload' onClick={() => window.location.reload()} />
          </Paper>
        </ErrorBoundaryWrapper>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
